import { SectionHeader } from "./SectionHeader";
import { useI18n } from "@/i18n";

export function WeatherSection() {
  const { t } = useI18n();

  return (
    <section id="bc-conditions" className="section-y border-y border-border bg-sand/60">
      <div className="container-page grid gap-12 lg:grid-cols-[minmax(0,0.9fr)_minmax(0,1.1fr)]">
        <SectionHeader eyebrow={t.weather.eyebrow} title={t.weather.title} body={t.weather.body} />

        <ul className="grid gap-6 sm:grid-cols-2">
          {t.weather.items.map((item) => (
            <li key={item.title} className="rounded-lg border border-border bg-card p-6">
              <h3 className="text-[0.95rem] font-semibold tracking-tight text-foreground">
                {item.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{item.body}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
